module.exports = __webpack_public_path__ + "img/sort-up.cd9c6375.svg";